import { TeamHolder } from '@pages/team/models/team.models'
import { ContextMenuItemEvent } from '@core/models/context-menu.models'
import { getMetricValueAndContext } from '@core/utils/context-menu.utils'
import { parseTeamToMetricDetailRequest } from '@features/metric-detail/parsers/team-metric-detail.parser'
import { parseTeamComparisonToMetricDetailRequest } from '@features/metric-detail/parsers/team-comparison-metric-detail.parser'
import { AggregationContext } from '@features/aggregations/models/aggregations.models'

export const resolveTeamMetricDetailRequestAdapter = (
  payload: ContextMenuItemEvent,
  { isVsEnabled }: AggregationContext
) => {
  const { context, value } = getMetricValueAndContext<TeamHolder>(payload)

  return isVsEnabled
    ? parseTeamComparisonToMetricDetailRequest(context.comparison, value)
    : parseTeamToMetricDetailRequest(context.team, value)
}
